import { convertirFormatoHora, formatDate, texto } from '@/shared';
import { gridSizeMdLg12, gridSizeMdLg6 } from '@/shared/constants';
import RefreshIcon from '@mui/icons-material/Refresh';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
  styled,
} from '@mui/material';
import { DateCalendar, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import { useState } from 'react';
import { CustomConfirmDialogProps } from '@/shared/components/ui/Dialogs';
import useCalendarioInstalacion from '@/store/erp/preagendamiento/useCalendarioInstalacion.store';
import { useFlotasStore } from '@/store/erp';
import { TabTextLabel } from '@/shared/components/ui';
import { CustomAlertCard } from '@/shared/components/ui/Alerts';

interface StyledPaperProps {
  isclicked: boolean;
}

const StyledPaper = styled(Paper)<StyledPaperProps>(({ isclicked }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '5px',
  borderRadius: '5px',
  color: isclicked ? 'white' : 'gray',
  backgroundColor: isclicked ? '#2b4c7e' : '#ffffff',
  transition: 'background-color 0.3s',
  cursor: !isclicked ? 'default' : 'pointer',
  border: '1px solid #E0E0E0',
  margin: '10px 0px',
}));


interface CustomPaperProps {
  id: string;
  children: React.ReactNode;
  onClick: (id: string) => void;
  isClicked: boolean;
}

const CustomPaper: React.FC<CustomPaperProps> = ({
  id,
  children,
  onClick,
  isClicked,
}) => {
  const handleClick = () => {
    onClick(id);
  };

  return (
    <StyledPaper onClick={handleClick} isclicked={isClicked}>
      {children}
    </StyledPaper>
  );
};

interface CalendarioPreagendamientoVentaProps {
  form: any
}

export default function CalendarioPreagendamientoVenta({
  form
}: CalendarioPreagendamientoVentaProps) {

  const {
    isLoadingPlanificacion,
    handleRecargarHoras,
    clickedIdHora,
    setClickedIdHora,
    countdown,
    horasDisponibles,
    fechaSelecionada,
    setFechaSelecionada,
    bloquear,
    modal,
    setModal,
    fechaHoraDisponible,
    minDate,
    maxDate,

    currentIndex,
    setCurrentIndex,

    handleVerificarHoraSeleccionada,
    handleObtenerPlanificacion,
  } = useCalendarioInstalacion();

  const { flotasPreagendamiento, isLoadingFlotasPreagendamiento } = useFlotasStore();

  const [horaAux, setHoraAux] = useState<number | null>(null);

  // Función para ir al siguiente técnico
  const handleNext = () => {
    if (currentIndex < flotasPreagendamiento.length - 1) {
      setCurrentIndex(currentIndex + 1);
      handleObtenerPlanificacion(flotasPreagendamiento.at(currentIndex + 1)?.codigo!)
      form.setValue('flota', flotasPreagendamiento.at(currentIndex + 1)?.codigo)
    }
  };

  // Función para ir al técnico anterior
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      handleObtenerPlanificacion(flotasPreagendamiento.at(currentIndex - 1)?.codigo!)
      form.setValue('flota', flotasPreagendamiento.at(currentIndex - 1)?.codigo)
    }
  };

  return (
    <>

      <Grid item container spacing={3} paddingTop={'20px'} justifyContent={'space-between'}>

        <Grid item {...gridSizeMdLg12}>
          <TabTextLabel
            text={texto.tecnicos_disponibles}
            pt={0}
            mt={0}
            pb={0}
            pl={0}
          />
        </Grid>

        {/* <CustomAutocomplete<Flota>
          disabled={bloquear}
          size={gridSizeMdLg12}
          label={'Técnicos Disponibles'}
          name="flota"
          options={flotasPreagendamiento || []}
          valueKey="nombre"
          actualValueKey="codigo"
          defaultValue={form.getValues().flota}
          isLoadingData={isLoadingFlotasPreagendamiento}
          control={form.control}
          error={undefined}
          helperText={undefined}
          onChangeValue={(value) => {
            handleObtenerPlanificacion(value)
          }}
        /> */}

        {!isLoadingFlotasPreagendamiento && (
          <Grid item xs={12} container spacing={3} alignItems={'center'} justifyContent={'space-between'}>
            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={handlePrev}
                disabled={currentIndex === 0 || bloquear}
                variant="contained"
                color="primary"
              >
                Regresar
              </Button>
            </Grid>

            {/* <Grid item >
              <Typography variant="h6">{flotasPreagendamiento.at(currentIndex)?.nombre}</Typography>
            </Grid> */}

            <Grid item xs={6}>
              <Button
                fullWidth
                onClick={handleNext}
                disabled={currentIndex === flotasPreagendamiento.length - 1 || bloquear}
                variant="contained"
                color="primary"
              >
                Ver Mas
              </Button>
            </Grid>

          </Grid>
        )
        }

        {!isLoadingPlanificacion ? (
          <>
            {fechaHoraDisponible != null && form.getValues().flota ? (
              <Grid item container {...gridSizeMdLg6} justifyContent={'center'} >
                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'start' }}>
                    Seleccionar Fecha de Instalación
                  </Typography>
                </Grid>

                <Grid item >
                  <FormControl fullWidth>
                    <LocalizationProvider
                      dateAdapter={AdapterDayjs}
                      adapterLocale="es"
                    >
                      <DemoContainer components={['DateCalendar']}>
                        <DateCalendar
                          /* shouldDisableDate={date =>
                            handleFechaCalendario(date.format('YYYY-MM-DD'))
                          } */
                          disabled={bloquear}
                          minDate={dayjs(minDate)}
                          maxDate={dayjs(maxDate)}
                          referenceDate={dayjs(new Date())}
                          views={['month', 'day']}
                          value={fechaSelecionada != null ? dayjs(fechaSelecionada) : null}
                          onChange={e => {
                            setFechaSelecionada(formatDate(e.toISOString()))
                          }
                          }
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </FormControl>
                </Grid>
              </Grid>
            ) : (
              <CustomAlertCard
                alertTitle='Información'
                alertColor='info'
                alertMessage={texto.flota_sin_planificacion}
              />
            )
            }


            {horasDisponibles && horasDisponibles?.length > 0 && (
              <Grid item container {...gridSizeMdLg6}>
                <Grid item xs={10}>
                  <Typography variant="subtitle1" sx={{ textAlign: 'start' }}>
                    Tiempo restante:
                  </Typography>
                </Grid>

                {clickedIdHora == null && (
                  <Grid item xs={2}>
                    <Tooltip title="Refrescar Horas" placement="top">
                      <IconButton
                        color="primary"
                        onClick={() => handleRecargarHoras()}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}

                <Grid item {...gridSizeMdLg12}>
                  <Paper
                    elevation={1}
                    sx={{
                      borderRadius: '3px',
                      padding: '5px',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      border: '1px solid #E0E0E0',
                    }}
                  >
                    <p>{`${Math.floor(countdown / 60)}:${countdown % 60
                      } minutos`}</p>
                  </Paper>
                </Grid>

                <Grid item {...gridSizeMdLg12}>
                  <Paper
                    sx={{
                      maxHeight: 250,
                      overflowY: 'auto',
                      margin: 'auto',
                      textAlign: 'center',
                    }}
                  >
                    {horasDisponibles?.map((e) => (
                      <CustomPaper
                        key={e.hora}
                        id={`id-${e.hora}`}
                        onClick={async () => {
                          setHoraAux(e.hora)
                          handleVerificarHoraSeleccionada(e.hora);
                        }
                        }
                        isClicked={clickedIdHora === `id-${e.hora}`}
                      >
                        {convertirFormatoHora(e.hora)}
                      </CustomPaper>
                    ))}
                  </Paper>
                </Grid>
              </Grid>
            )}
          </>
        ) : (
          <Grid item xs={12} justifyContent={'center'} textAlign={'center'} justifyItems={'center'}>
            <CircularProgress />
          </Grid>
        )

        }


      </Grid >

      {/* Modal de confirmar hora */}
      {
        <CustomConfirmDialogProps
          open={modal}
          title="Seleccionar horario de instalación"
          subtitle="¿Está seguro de querer agendar la instalacion en este horario?"
          text2={texto.mensaje_bloquar_horario_10_min}
          confirmTextBtn="Si, seleccionar horario"
          onClose={() => {
            setModal(false);
            setHoraAux(null);
          }}
          onConfirm={() => {
            setClickedIdHora(`id-${horaAux}`);
            setModal(false);
          }}
        />
      }
    </>
  )
}
